import { useState, useEffect } from "react";
import { useLocation } from "react-router";
import { IconChevronDown } from "../../assets/icons";

const ScrollToTop = () => {
  const loc = useLocation()
  const [isVisible, setIsVisible] = useState(false);

  // بررسی موقعیت اسکرول
  const toggleVisibility = () => {
    if (window.scrollY > 500) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // اسکرول به بالای صفحه
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    // اضافه کردن event listener هنگام mount
    window.addEventListener("scroll", toggleVisibility);

    // حذف event listener هنگام unmount
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    isVisible && (
      <div style={{ bottom: loc.pathname.includes("details") ? 125 : 75 }} className="btn-up rounded-circle small-svg" onClick={scrollToTop}>
        <div style={{ top: 2 }} className="position-relative">
          <IconChevronDown fillColor="white" />
        </div>
      </div>
    )
  );
};
export default ScrollToTop;
